import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
export default {
  title: 'Subtitle config',
  attributeName: 'subtitle',
  default: [],
  validationUrl: 'live',
  hiddenJsonComponent: true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden: true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden: true
    },
    {
      attributeName: 'captions',
      type: FormInputTypes.CHECKBOX,
      itemLabel: 'captions',
      default: false,
      columns: 2,
      label: 'captions',
      helpText: 'Are these captions subtitles?',
      errorText: '',
      classCss: "jsonComponent__width100",
      visibleWhen: [{ "field": "deploymentType", "value": "ott" }]
    },
    {
      attributeName: 'language',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'language',
      label: 'language',
      pattern: /^[A-Za-z-]+$/,
      required: true,
      helpText: 'Set the video language.',
      errorText: '',
    },
    {
      attributeName: 'variant',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'variant',
      columns: 2,
      pattern: /^[a-zA-Z0-9]+$/,
      visibleWhen: [{ "field": "deploymentType", "value": 'ott' },{ field: "captions", value: "bool-false" }],
      placeholder: 'text or number',
      helpText: 'Chosoe the http audio variant',
      classCss: "jsonComponent__width100",
      errorText: '',
    }
  ]
};
